// src/ui/EmptyState.tsx (T1): a quiet row between hairlines for "nothing here yet" (D's room .ideas-empty):
// one short line, an optional action. No illustration (docs/DECISIONS.md). Root class: hb-empty.
import type { ComponentChildren } from "preact";
import { cx } from "./cx";
import { Icon, type IconName } from "./Icon";

export function EmptyState(props: {
  title: ComponentChildren;
  /** One short line at most. */
  sub?: ComponentChildren;
  icon?: IconName;
  action?: ComponentChildren;
  class?: string;
}) {
  return (
    <div class={cx("hb-empty", props.class)}>
      {props.icon ? (
        <span class="hb-empty-ic" aria-hidden="true">
          <Icon name={props.icon} />
        </span>
      ) : null}
      <div class="hb-empty-t">
        <p class="hb-empty-title">{props.title}</p>
        {props.sub ? <p class="hb-empty-sub">{props.sub}</p> : null}
      </div>
      {props.action ? <div class="hb-empty-act">{props.action}</div> : null}
    </div>
  );
}
